import * as React from "react";

function PlinSimple(props) {
  return (
    <svg
      width={24}
      height={24}
      viewBox="34 14 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M52,14.57c-9.63,0-17.43,7.8-17.43,17.43,0,2.03.34,3.97.98,5.78.4,2.27.45,3.28.15,4.83-.21,1.12-.85,1.84-.74,2.89.1.94.17,1.49,1.02,2.4,1,1.02,1.93.95,2.22,1,1.03.16,1.79-.43,2.91-.56,1.76-.22,3.04-.34,5.92.37,0,0,.02,0,.03,0,1.57.47,3.22.71,4.94.71,9.63,0,17.43-7.81,17.43-17.43s-7.81-17.43-17.43-17.43ZM44.1,37.18c-.55,0-1.08-.1-1.54-.31-.26-.12-.55.09-.55.37v1.93c0,.68-.59,1.22-1.29,1.16-.61-.06-1.06-.61-1.06-1.23v-8.02c0-1.02-.07-2.64-.07-2.64-.04-.51.71-.46.71-.46h1.12c.31,0,.31.1.36.17.07.09.16.38.8.03.52-.26,1.12-.39,1.76-.39,2.26,0,3.89,1.93,3.89,4.59,0,3.3-2.14,4.8-4.14,4.8ZM51.59,35.83c0,.65-.52,1.17-1.18,1.17-.61,0-1.12-.46-1.17-1.06v-10.7c.06-.6.56-1.06,1.17-1.06.66,0,1.18.52,1.18,1.17v10.48ZM55.56,35.83c0,.65-.53,1.17-1.17,1.17-.5,0-1.19-.21-1.19-1.17v-6.88c0-.67.7-.96,1.19-.96.64,0,1.17.52,1.17,1.17v6.67ZM54.42,27.54c-.65,0-1.18-.52-1.18-1.18s.53-1.17,1.18-1.17,1.18.52,1.18,1.17-.52,1.18-1.18,1.18ZM63.86,37c-.53.04-1.25-.14-1.29-1.17v-3.96c0-1.31-.48-1.96-1.44-1.96-.83,0-1.38.6-1.56,1.2v.02c-.06.12-.09.33-.09.54v4.09c0,.63-.46,1.19-1.08,1.24-.53.04-1.04-.28-1.23-.73,0,0-.04-.02-.05-.44v-5.2c0-.91-.02-1.55-.07-2.17-.02-.25.18-.47.44-.47h1.32c.15,0,.24.13.36.19.12.07.62.1.82,0,.5-.24,1.04-.37,1.62-.37,1.53,0,3.32,1.03,3.32,3.91v4.06c0,.63-.46,1.19-1.08,1.24Z"
        fill="currentColor"
      />
      <path
        d="M45.89,32.44c0,1.69-.76,2.7-2.04,2.7-.84,0-1.56-.55-1.78-1.38-.04-.17-.06-.33-.06-.51v-1.39c0-.16.05-.35.09-.5.23-.89.97-1.51,1.81-1.51,1.36,0,1.98,1.31,1.98,2.59Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default PlinSimple;
